export default "__VITE_PUBLIC_ASSET__11588ec2__"